import apiClient from '@/services/api-client';
import { API_ENDPOINTS } from '@/lib/constants/api-endpoints';
import type { IApiSuccessResponse } from '@/types/api.types';

export interface PresignedGetResponse {
  url: string;
  expiresIn: number;
}

export interface PresignedUploadResponse extends PresignedGetResponse {
  key: string;
}

export async function getPresignedGetUrl(
  key: string,
): Promise<PresignedGetResponse> {
  const response = await apiClient.get<IApiSuccessResponse<PresignedGetResponse>>(
    API_ENDPOINTS.FILES.PRESIGN_GET,
    {
      params: { key },
    },
  );

  return response.data.data;
}

export async function getPresignedUploadUrl(
  fileName: string,
  contentType: string,
): Promise<PresignedUploadResponse> {
  const response = await apiClient.post<
    IApiSuccessResponse<PresignedUploadResponse>
  >(API_ENDPOINTS.FILES.PRESIGN_UPLOAD, undefined, {
    params: { fileName, contentType },
  });

  return response.data.data;
}

